import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import VideoCard from 'components/Quick_Installation/Videos/video-powerline';
import ForumBox from 'components/Quick_Installation/Powerline/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "IN-LAN Powerline",
  "path": "/Schnell_Installation/Powerline/Video/",
  "dateChanged": "2017-09-26",
  "author": "Mike Polinowski",
  "excerpt": "IN-LAN ist eine intelligente und sichere Technologie, die es Ihnen auf einfach Weise erlaubt ein Hochgeschwindigkeitsdatennetzwerk über Ihr Stromnetz aufzubauen - ohne die komplexe und kostenintensive Verkabelung die ein reguläres LAN benötigt.",
  "image": "./QI_SearchThumb_Powerline.png",
  "social": "/images/Search/QI_SearchThumb_Powerline.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-LAN_white.webp",
  "chapter": "Installation"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const NavButtons = makeShortcode("NavButtons");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='INSTAR Powerline Adapter – INSTAR Wiki' dateChanged='2017-09-26' author='Mike Polinowski' tag='INSTAR IP Camera' description='IN-LAN ist eine intelligente und sichere Technologie, die es Ihnen auf einfach Weise erlaubt ein Hochgeschwindigkeitsdatennetzwerk über Ihr Stromnetz aufzubauen - ohne die komplexe und kostenintensive Verkabelung die ein reguläres LAN benötigt.' image='/images/Search/QI_SearchThumb_Powerline.png' twitter='/images/Search/QI_SearchThumb_Powerline.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Quick_Installation/Powerline/' locationFR='/fr/Quick_Installation/Powerline/' crumbLabel="Powerline" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "powerline",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#powerline",
        "aria-label": "powerline permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Powerline`}</h1>
    <p><strong parentName="p">{`IN-LAN`}</strong>{` ist eine intelligente und sichere Technologie, die es Ihnen auf einfach Weise erlaubt ein Hochgeschwindigkeitsdatennetzwerk über Ihr Stromnetz aufzubauen - ohne die komplexe und kostenintensive Verkabelung die ein reguläres LAN benötigt. IN-LAN bietet Ihnen Datentransferraten bandbreitenintensiver Anwendungen wie Sie sie von einem regulären LAN gewöhnt sind. IN-LAN erlaubt Ihnen die Verbindung zwischen Ihrem Computer und Netzwerk-Geräten aufzubauen wo eine stabile WLAN Verbindung nicht mehr möglich ist. IN-LAN verwandelt jede Steckdose in einen Access Point mit einer state-of-the-art Technologie die Ihnen eine strikte Trennung zwischen Strom- und Datennetzwerk garantiert  => `}<a parentName="p" {...{
        "href": "/de/Produkte/IN-LAN/"
      }}>{`Installation`}</a></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <VideoCard mdxType="VideoCard" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      